var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { agreementsCommon, baseCommon, configCommon, merchantCommon, } from '@repo/api/endpoints/merchant/msw/mocks/common';
export var STEP_3_LIBERIS_NOTIFICATION_PENDING = __assign(__assign({}, baseCommon), { type: 'IFRAME_MERCHANT_SUMMARY', currentProvider: ['test-provider'], data: {
        merchantData: __assign(__assign({}, merchantCommon), { user: {
                type: 'user',
                userId: 12345,
                permission: {
                    widget: true,
                    newLoan: true,
                    cancelLoan: true,
                    continueLoan: true,
                },
                accessFor: ['193421', '1234', '4321'],
            } }),
        preLimits: [
            {
                id: 12345,
                min: 3000,
                max: 132832,
                currency: 'PLN',
                provider: 'test-provider',
                availableLimitRevenueRate: [
                    {
                        period: 12,
                        pricing: 30,
                        loanRepaymentPrice: 3.6,
                        amountMin: 10000,
                        amountMax: 20000,
                    },
                    {
                        period: 6,
                        pricing: 30,
                        loanRepaymentPrice: 3.6,
                        amountMin: 10000,
                        amountMax: 20000,
                    },
                ],
            },
        ],
        limits: [
            {
                id: 12345,
                preLimitId: 12345,
                min: 3000,
                max: 132832,
                used: 37477,
                currency: 'PLN',
                provider: 'test-provider',
                available: 0,
                minMaxDifference: false,
                availableLimitRevenueRate: [
                    {
                        period: 12,
                        pricing: 30,
                        loanRepaymentPrice: 3.6,
                        amountMin: 10000,
                        amountMax: 20000,
                    },
                    {
                        period: 6,
                        pricing: 30,
                        loanRepaymentPrice: 3.6,
                        amountMin: 10000,
                        amountMax: 20000,
                    },
                ],
            },
        ],
        loans: [
            {
                id: 12345,
                limitId: 12345,
                amount: 37477,
                currency: 'PLN',
                period: 12,
                pricing: 30,
                loanRepaymentPrice: 3.6,
                name: '',
                iban: 'PL68102045645609879769242394',
                provider: 'test-provider',
                stage: 3,
                providerRequest: 'requested',
                sms: [1],
                loanRepaymentAccounts: [],
                previousStage: null,
                createdAt: '2024-02-18 12:12:33',
                documents: [],
                loanAmountChange: false,
            },
        ],
        transfers: [],
        agreements: agreementsCommon,
        offers: [],
    }, config: configCommon });
